<template>
  <div id="navbar">
    <b-navbar
      toggleable="md"
      fixed="top"
      class="navbar-transition"
      :class="{ 'navbar-dark': navbarDark }"
    >
      <b-navbar-brand to="/">
        <img src="../assets/img/logo2.png" id="logo" class="d-inline-block align-top" alt="The Frizlen Group Logo">
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item to="about">About</b-nav-item>
          <b-nav-item to="portfolio">Portfolio</b-nav-item>
          <!-- <b-nav-item href="/news">News</b-nav-item> -->
          <b-nav-item href="https://buffalofts.com" target="_blank">Leasing</b-nav-item>
          <b-nav-item to="contact">Contact</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div><!-- /#navbar -->
</template>

<script>
export default {
  data () {
    return {
      navbarDark: false
    }
  },
  mounted () {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll () {
      // Get the current scroll position
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
      if (currentScrollPosition < 0) {
        return
      }
      // Here we determine whether we need to show or hide the navbar
      this.navbarDark = currentScrollPosition > 50
      // Set the current scroll position as the last scroll position
      this.lastScrollPosition = currentScrollPosition
    }
  }
}
</script>

<style scoped>
#logo {
  height: 60px;
  padding: 5px;
}

.navbar-light .navbar-nav .nav-link {
  color: #eee;
  text-transform: uppercase;
  font-size: 14px;
}

.navbar-transition {
  transition: all 0.3s ease;
}

.navbar-dark {
  background-color: rgba(0,0,0,0.9);
}

@media(max-width: 767px) {
  #logo {
    height: 40px;
    background-color: rgba(255,255,255,0.9);
    border-radius: 4px;
    padding: 5px;
  }
  .navbar {
    background-color: #333;
  }
  .navbar-toggler {
    background-color: #eee;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue